module.exports = __webpack_public_path__ + "static/img/pifu.d15206e6.svg";